import React from 'react';
import { useParams } from 'react-router-dom';
import Survey from './Survey';
import NotFound from './NotFound';

// Los PIN de diagnóstico son números (6 cifras). Antes cualquier dirección de un tramo (/loquesea) abría la
// pantalla de responder como si fuera un PIN; ahora solo los números, y lo demás es la página 404.
// Con un número que no existe, la propia encuesta ya dice "No encontramos este diagnóstico".
export const isPin = (value) => /^\d+$/.test(String(value || ''));

const PinOrNotFound = () => {
  const { pin } = useParams();
  return isPin(pin) ? <Survey /> : <NotFound />;
};

export default PinOrNotFound;
